<template>
  <div>
    <b-modal ref="procedureModal" hide-footer lazy size="xl">
      <template #modal-title>
        <h3>
          Procedure
        </h3>
      </template>

      <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(upsertProcedure)">
          <b-row>
            <b-col>
              <base-input
                rules="required"
                label="Procedure Name"
                name="Procedure Name"
                v-model="procedure.procedureName"
              ></base-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <label class="form-control-label">
                Summary
              </label>
              <b-form-textarea
                rules="required"
                rows="3"
                placeholder="Procedure Summary"
                size="4"
                v-model="procedure.procedureSummary"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col>
              <base-input
                label="Minutes"
                name="Minutes"
                rules="required|greaterThanZero"
                v-model="procedure.minutes"
              ></base-input>
            </b-col>
            <b-col>
              <base-input-currency
                label="Deposit"
                name="Deposit"
                rules="money|required"
                v-model="procedure.deposit"
              ></base-input-currency>
            </b-col>
            <b-col>
              <base-input-currency
                label="Cancelation Fee"
                name="Cancelation Fee"
                rules="money|required"
                v-model="procedure.cancelationFee"
              ></base-input-currency>
            </b-col>
            <b-col>
              <base-input-currency
                label="Price"
                name="Price"
                rules="money|required"
                v-model="procedure.price"
              ></base-input-currency>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                switch
                class="mt-2"
                size="sm"
                v-model="procedure.isActive"
                @change="bind"
                >Active</b-form-checkbox
              >
            </b-col>
          </b-row>
          <button type="submit" class="btn btn-success mt-4">
            Update Procedure
          </button>
        </b-form>
      </validation-observer>
    </b-modal>
    <card>
      <b-row>
        <b-col>
          <h1>Procedures</h1>
        </b-col>
        <b-col class="text-right">
          <b-button variant="primary" @click="addProcedure"
            >Add Procedure</b-button
          >
        </b-col>
      </b-row>

      <b-form-checkbox
        switch
        class="mt-3"
        size="sm"
        v-model="isActive"
        @change="bind"
        >Active</b-form-checkbox
      >
      <b-table
        striped
        hover
        :items="procedures"
        @row-clicked="procedureSelected"
      >
        <template #cell(deposit)="data">
          {{ (data.value / 100) | currency }}
        </template>
        <template #cell(cancelationFee)="data">
          {{ (data.value / 100) | currency }}
        </template>
        <template #cell(price)="data">
          {{ (data.value / 100) | currency }}
        </template>
      </b-table>
    </card>
  </div></template
>

<script>
export default {
  data() {
    return {
      procedures: [],
      procedure: {},
      isActive: true,
    };
  },
  async created() {
    this.bind();
  },
  methods: {
    async upsertProcedure() {
      if (this.procedure.cancelationFee < this.procedure.deposit) {
        this.$emitter.emit(
          "error",
          "Cancelation fee must be greater than deposit"
        );
        return;
      }

      var r = await this.$client.post("/api/procedure/upsert", this.procedure);
      if (r.data.isSuccess) {
        this.$refs.procedureModal.hide();
        this.$emitter.emit("success", {
          title: "Saved",
          message: "Procedure saved",
        });
        this.bind();
      }
    },
    async procedureSelected(item) {
      let r = await this.$client.get(
        "/api/procedure/getProcedure?id=" + item.id
      );
      if (r.data.isSuccess) {
        r.data.value.price = r.data.value.price.toFixed(0) / 100;
        r.data.value.deposit = r.data.value.deposit.toFixed(0) / 100;
        r.data.value.cancelationFee =
          r.data.value.cancelationFee.toFixed(0) / 100;

        this.procedure = r.data.value;

        this.$refs.procedureModal.show();
      }
    },
    addProcedure() {
      this.procedure = { isActive: true };
      this.$refs.procedureModal.show();
    },
    async bind() {
      let r = await this.$client.get(
        "/api/procedure/getProcedures?isActive=" + this.isActive
      );
      if (r.data.isSuccess) {
        this.procedures = r.data.value;
      }
    },
  },
};
</script>

<style></style>
